// Shared category taxonomy for Vault — was duplicated separately in
// VaultPage.jsx and VaultCredentialModal.jsx, consolidated here so there's
// one place to add/rename/recolor a category.
export const CATEGORIES = [
  { key: 'Banking & Finance', label: 'Banking & Finance' },
  { key: 'E-commerce', label: 'E-commerce' },
  { key: 'Marketing & Ads', label: 'Marketing & Ads' },
  { key: 'Social Media', label: 'Social Media' },
  { key: 'Customer Support', label: 'Customer Support' },
  { key: 'Suppliers & Manufacturing', label: 'Suppliers & Manufacturing' },
  { key: 'Cloud & Infrastructure', label: 'Cloud & Infrastructure' },
  { key: 'Domains & DNS', label: 'Domains & DNS' },
  { key: 'Dev & Code', label: 'Dev & Code' },
  { key: 'Comms & Email', label: 'Comms & Email' },
  { key: 'AI & Data', label: 'AI & Data' },
  { key: 'Productivity & Ops', label: 'Productivity & Ops' },
  { key: 'Other', label: 'Other' },
];

export const CATEGORY_COLORS = {
  'Banking & Finance': '#16a34a',
  'E-commerce': '#2563eb',
  'Marketing & Ads': '#db2777',
  'Social Media': '#e11d48',
  'Customer Support': '#0891b2',
  'Suppliers & Manufacturing': '#ca8a04',
  'Cloud & Infrastructure': '#7c3aed',
  'Domains & DNS': '#4f46e5',
  'Dev & Code': '#0f172a',
  'Comms & Email': '#0d9488',
  'AI & Data': '#9333ea',
  'Productivity & Ops': '#d97706',
  'Other': '#64748b',
};

// FON-specific examples per category, from Mo's original taxonomy table —
// shown as a hint under the Category field when adding/editing a credential
// (not in the main list — that stays uncluttered).
export const CATEGORY_EXAMPLES = {
  'Banking & Finance': 'Bank logins, Xero, payment processors, Stripe/PayPal, BAS/accountant portals',
  'E-commerce': 'Shopify admin, Skio (subscriptions), checkout/POS tools',
  'Marketing & Ads': 'Meta Ads, Google Ads, Klaviyo, GA4, Fairing, ad accounts',
  'Social Media': 'Instagram, TikTok, Facebook Pages, YouTube',
  'Customer Support': 'Gorgias, help-desk, review platforms',
  'Suppliers & Manufacturing': 'Phytotherapy & other supplier portals, freight/3PL, Skutopia',
  'Cloud & Infrastructure': 'AWS, Fly.io, hosting, CDN',
  'Domains & DNS': 'Registrar, DNS manager, SSL',
  'Dev & Code': 'GitHub, npm, API dashboards',
  'Comms & Email': 'Microsoft 365, Slack, email admin',
  'AI & Data': 'Anthropic, Modal, HuggingFace',
  'Productivity & Ops': 'Asana, Dropbox, Fireflies, Google Workspace',
  'Other': "Anything that doesn't fit",
};

// Groups a credential list into taxonomy-ordered sections (not alphabetical
// — sections read in the business's own priority order), skipping any
// category with zero items. Shared by VaultPage's main list and
// VaultAccessModal's per-credential access picker so both browse the same way.
export function groupByCategory(credentials) {
  return CATEGORIES
    .map(cat => ({
      key: cat.key,
      label: cat.label,
      color: CATEGORY_COLORS[cat.key] || '#64748b',
      items: credentials.filter(c => (c.category || 'Other') === cat.key),
    }))
    .filter(group => group.items.length > 0);
}
